var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "experiences-container" }, [
    _c("div", { staticClass: "experiences-label mb-2" }, [
      _vm._v(_vm._s(_vm.experiences.title)),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "experiences-list" },
      _vm._l(_vm.experiences.experiences, function (item, index) {
        return _c("ExperienceItem", {
          key: index,
          attrs: { experience: item },
          on: { click: _vm.handleSuggestionClick },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }